import axios from 'axios';

const Axios = axios.create({
    baseURL: 'https://allosaurus-uat.vetfile.co.uk/backend/api'
    // baseURL: 'http://localhost:8001/api'
})

export default Axios;
